'use strict';

$(document).ready(function () {
    var arr = document.querySelectorAll('.attrval p');
    var index = 0;
    if (arr.length <= 5) {
        $('.prev-arrow').addClass('d-none');
        $('.next-arrow').addClass('d-none');
    }
    while (index < arr.length) {
        if (index > 4) {
            arr[index].style.display = 'none';
        }
        index += 1;
    }
    index = 5;

    $('.next-arrow').on('click', function () {
        if (index >= arr.length) {
            return;
        }
        var count = 0;
        var j = index;
        var i = index + 5;
        while (count < arr.length) {
            if (count >= j && count < i) {
                arr[count].style.display = 'block';
            } else {
                arr[count].style.display = 'none';
            }
            count += 1;
        }
        index = j + 5;
    });

    $('.prev-arrow').on('click', function () {
        if (index === 5) {
            return;
        }
        var count = 0;
        var j = index - 5;
        var i = index - 10;
        while (count < arr.length) {
            if (count >= i && count < j) {
                arr[count].style.display = 'block';
            } else {
                arr[count].style.display = 'none';
            }
            count += 1;
        }
        index -= 5;
    });
});
